/**
 * Icons shared by the product tile and the brand page list row so both
 * surfaces show the same glyphs. Kept as inline SVG because Slate has no
 * equivalent for the find-similar magnifier-with-sparkle mark.
 */

export const HeartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ color: "#6b6b6b" }}
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

export const FilledHeartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="#921100"
    stroke="#921100"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

/** Magnifying glass with a sparkle — matches the Similar products page. */
export const FindSimilarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_find_similar_tile)">
      <rect width="16" height="16" fill="white" />
      <path
        d="M9.89584 11.5091C8.87995 12.525 7.50212 13.0957 6.06544 13.0957C4.62876 13.0957 3.25092 12.525 2.23504 11.5091C1.21916 10.4932 0.648438 9.1154 0.648438 7.67872C0.648437 6.24204 1.21916 4.86421 2.23504 3.84832C3.25092 2.83244 4.62876 2.26172 6.06544 2.26172C7.50212 2.26172 8.87995 2.83244 9.89584 3.84832C10.9117 4.86421 11.4824 6.24204 11.4824 7.67872C11.4824 9.1154 10.9117 10.4932 9.89584 11.5091ZM9.89584 11.5091L13.6485 15.2617"
        stroke="#333333"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1309 -0.525391C11.4483 -0.525388 11.846 -0.346138 11.9854 0.0761719L12.0098 0.163086L12.1299 0.658203C12.4134 1.7464 12.7248 2.38687 13.1689 2.83105C13.6765 3.33862 14.4403 3.67276 15.8359 3.99023C16.321 4.10056 16.5254 4.53062 16.5254 4.86914C16.5254 5.20756 16.3216 5.63755 15.8369 5.74805C14.4411 6.06554 13.6766 6.3996 13.1689 6.90723C12.6614 7.41479 12.3272 8.17861 12.0098 9.57422C11.8994 10.0593 11.4694 10.2637 11.1309 10.2637C10.7923 10.2637 10.3623 10.0593 10.252 9.57422C9.93448 8.17861 9.60034 7.41479 9.09277 6.90723C8.58511 6.3996 7.82065 6.06554 6.4248 5.74805C5.94006 5.63758 5.73633 5.20758 5.73633 4.86914C5.73633 4.5307 5.94005 4.10071 6.4248 3.99023C7.82063 3.67271 8.5851 3.33873 9.09277 2.83105C9.60045 2.32338 9.93443 1.55891 10.252 0.163086C10.3624 -0.321668 10.7924 -0.525393 11.1309 -0.525391Z"
        fill="#333333"
        stroke="white"
        strokeWidth="1.25"
      />
    </g>
    <defs>
      <clipPath id="clip0_find_similar_tile">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000000"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);
